import {IStore} from '../store';
import {IPlayerStore} from './player.interface';
import SpotifyNowPlaying from '../../spotify/spotifyNowPlaying';

export const playerSelector: (state: IStore) => IPlayerStore =
  (state: IStore) => state.player;

export const nowPlayingSelector: (state: IStore) => SpotifyNowPlaying | null =
  (state: IStore) => playerSelector(state).nowPlaying;
